import React from 'react';
import { useBanners } from '../../../../hooks/useBanners';
import { BANNER_CATEGORY } from '../../../../constants/bannerCategory';
import AntdCarousel from '../../../../components/carousel/AntdCarousel';
import { LmsInfoTypes } from '../../../../constants/types';

/**
 * LMS 배너 컴포넌트
 * TODO: 추후 배너 타입에 따라 다른 배너 리스트 동적으로 받아서 사용
 */
const LmsBanner = ({ lmsLists }: { lmsLists: LmsInfoTypes }) => {
  const { banners, loading, handleBannerClick } = useBanners(
    BANNER_CATEGORY.LMS,
  );
  return (
    <>
      <AntdCarousel
        bannerItems={banners}
        loading={loading}
        handleBannerClick={handleBannerClick}
      />
    </>
  );
};

export default LmsBanner;
